import { MatDialog } from '@angular/material/dialog';
import { Injectable } from '@angular/core';
import { ApiService } from 'app/shared/apis/api.service';
import { BaseService } from 'app/core/services/base.service';
import { FileFinanceModel } from 'app/models/file_finance.model';

@Injectable({
    providedIn: 'root',
})
export class FileFinanceService extends BaseService<FileFinanceModel> {
    constructor(api: ApiService, _matDialog: MatDialog) {
        super(api, _matDialog, 'fileFinance');
    }
}
